import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { NgIf, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-percent-cell-renderer',
  templateUrl: './percent-cell-renderer.component.html',
  styleUrls: ['./percent-cell-renderer.component.css'],
  standalone: true,
  imports: [NgIf, DecimalPipe]
})
export class PercentCellRendererComponent implements AfterViewInit {
  params: any;
  cellValue: any;
  constructor() {}
  @ViewChild('content', { static: false }) container?: ElementRef;

  @ViewChild('trigger') button: any;

  ngAfterViewInit(): void {}

  agInit(params: any) {
    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}
